import type { AddedFilter } from '../../lib/filter-search.js';
import { type FilterKey, isCustomFilterKey } from '../filters/filterCatalog.js';

export type RunFilters = Partial<Record<FilterKey | 'creativeType', string[]>>;

// A run's scope goes to the actions service, which has no field for a tenant-declared dimension.
export function runFilters(added: AddedFilter[], creativeType: string[] = []): RunFilters {
  const filters: RunFilters = {};
  if (creativeType.length > 0) filters.creativeType = creativeType;
  for (const filter of added) {
    if (isCustomFilterKey(filter.key)) continue;
    if (filter.values.length > 0) filters[filter.key] = filter.values;
  }
  return filters;
}
